import ImageStepThree from "@/assets/dearis-pre-setting-step-three.png";
import ImageStepTwo from "@/assets/dearis-pre-setting-step-two.png";
import ImageStepOne from "@/assets/patmo-pre-setting-step-one.png";
import type { StepsDataModal } from "@/components/step";

export const dearisStepsData: StepsDataModal = {
  steps: [
    // step 1
    [
      {
        type: "text",
        content: "デバイスのホーム画面に戻り、Pabbitのボタンを押します。",
        indicator: 1,
      },
      { type: "image", content: ImageStepOne },
    ],
    // step 2
    [
      {
        type: "text",
        content: "この画面の左上を連続して３回タッチします。",
        indicator: 2,
      },
      { type: "image", content: ImageStepTwo },
    ],
    // step 3
    [
      {
        type: "text",
        content: "デバイスがこのページを表示することを確認します。",
        indicator: 3,
      },
      {
        type: "image",
        content: {
          src: ImageStepThree,
          caption: "dearisの設定ページ",
        },
      },
    ],
  ],
};
